import React, { useState } from "react";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import InvigilationProvider from "../context";
import useRequest from "../../../../utils/useRequest";
import { getExamStudentAllRecordList } from "../../../../service/exam";
import AsideAll from "./components/AsideAll";

export default function All() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentAllRecordList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    return (
        <InvigilationProvider
            examId={examId}
            setExamId={setExamId}
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}>
            <Layout
                refresh={refresh}
                title="参考全过程记录"
                table={
                    <StuTable
                        onErrChange={refresh}
                        dataSource={data?.dataList || []}
                        loading={loading}
                    />
                }
                aside={<AsideAll />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
